import { TPagination } from 'src/@types';

export const MOBILE_MAX_WIDTH = 768;
export const MOBILE_FIXED_WIDTH = 450;
export const HEADER_HEIGHT = 64;
export const FOOTER_HEIGHT = 70;
export const PAGE_PADDING = 24;
export const BOTTOM_BTN_HEIGHT = 80;

// 공통코드 - 부모코드명
export const COMMON_CODE_NAME = {
  ACNT_STTS_CD: 'ACNT_STTS_CD',
  GENDER_TYPE_CD: 'GENDER_TYPE_CD',
  USER_TYPE_CD: 'USER_TYPE_CD',
  TERMS_TYPE_CD: 'TERMS_TYPE_CD',
  HSPTL_CD: 'HSPTL_CD',
  MED_QST_TYPE_CD: 'MED_QST_TYPE_CD',
  MEDICINE_CD: 'MEDICINE_CD',
  ALARM_TYPE_CD: 'ALARM_TYPE_CD',
  MISSION_TYPE_CD: 'MISSION_TYPE_CD',
  FTND_RESULT_CD: 'FTND_RESULT_CD',
  CRAVING_TYPE_CD: 'CRAVING_TYPE_CD',
  FAQ_TYPE_CD: 'FAQ_TYPE_CD',
  OS_TYPE_CD: 'OS_TYPE_CD',
  FILTER_TYPE_CD: 'FILTER_TYPE_CD',
};

// 부모코드ID
export const COMMON_CODE_PID = {
  FILTER_TYPE_CD: 6200,
};

// 약관 유형 코드
export const TERMS_TYPE_CODE = {
  SERVICE: 4000001,
  PRIVACY_POLICY: 4000002,
  REGISTER: 4000003,
  MARKETING: 4000004,
};

// 사용자 유형 코드
export const USER_TYPE_CD = {
  USER: 1007001,
  ADMIN: 1007002,
  MEDICALSTAFF: 1007003,
};

// 갈망원인 유형 코드
export const CRAVING_TYPE_CD = {
  STRESS: {
    code: 5900001,
    color: '#1E1C5D',
  },
  WORRY_DECISION: {
    code: 5900002,
    color: '#3831A1',
  },
  WHEN_BORED: {
    code: 5900003,
    color: '#554AEE',
  },
  WHEN_ANXIOUS: {
    code: 5900004,
    color: '#756CF9',
  },
  WHEN_FEELING_LONELY: {
    code: 5900005,
    color: '#034387',
  },
  DRINKING_OCCASIONS: {
    code: 5900006,
    color: '#05529F',
  },
  DURING_MEALS: {
    code: 5900007,
    color: '#0468C8',
  },
  TOBACCO_OFFER: {
    code: 5900008,
    color: '#2E96F9',
  },
  AROUND_SMOKERS: {
    code: 5900009,
    color: '#1A808C',
  },
  NICOTINE_WITH_DRAWAL_SYMPTOMS: {
    code: 5900010,
    color: '#20A4B1',
  },
  NICOTIN_DEPENDENCE_CRAVING: {
    code: 5900011,
    color: '#2FB49F',
  },
  HABITUALLY: {
    code: 5900012,
    color: '#FF643C',
  },
  UPON_WAKING_UP_IN_THE_MORNING: {
    code: 5900013,
    color: '#F9CA32',
  },
  AFTER_MEALS: {
    code: 5900014,
    color: '#FFA127',
  },
  IN_HAPPY_JOYFUL_SITUATIONS: {
    code: 5900015,
    color: '#D20540',
  },
  BREAK_TIME: {
    code: 5900016,
    color: '#FD4583',
  },
};

// 금연변화동기평가상태 유형 코드
export const KSCMS_STATUS_TYPE_CODE = {
  PREREFLECTION: 5800001,
  REFLECTION: 5800002,
  PREPARATION: 5800003,
};

export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PAGINATION: TPagination = {
  page: 1,
  size: DEFAULT_PAGE_SIZE,
  offset: 0,
  numberOfElements: 0,
  totalElements: 0,
  totalPages: 0,
  first: true,
  last: false,
};

export const LANGUAGE = {
  korean: 'ko',
  english: 'en',
  deutsch: 'de',
};
